module.exports = __webpack_public_path__ + "img/web-performance-after.0cd035d9.jpeg";